import { GeoService } from 'cartoservice/static/cartoservice/src/classes';
import { Attribute, Service } from '.';

export class Layer {
  id: number;
  object_id: number;
  service: Service | GeoService;
  title: string;
  visible = false;
  sublayers: Layer[] = [];
  project: string;
  resource_uri: string;
  attributes: Attribute[];
  parent: Layer;
  is_group = false;
  layer_type: string;
  order: number;
  editable = false;
  service_editable = false;
  popup_image = false;
  popup_chart = false;
  searchable = true;
  time = false;
  backColor = '#f4f4f4';
  inTooltipDefault = true;

  subLayers: Layer[] = [];
  name: string;
  isGroup: boolean;
  type: string;
  content_object: string;

  crowdsource = false;
  crowdsource_btn_text = 'Создать объект';
  crowdsourceAttributes: Attribute[] = [];

  constructor(options?: any) {
    if (options) {
      Object.assign(this, options);

      if (!this.layer_type && this.service instanceof Service) {
        this.layer_type = this.service.geom_type ? this.service.geom_type : this.service.type;
      }
    }
  }
}
